import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, ViewContainerRef } from "@angular/core";
import { SharedService } from '../shared';
import { DatenubersichtCommonComponent } from './datenubersicht-common.component';
import { LANGUAGE_ENUM } from "../dateneingabe-frageboge/questionnaire.model";

@Component({
    selector: 'app-datenubersicht',
    templateUrl: "./datenubersicht.component.html",
    styleUrls: ["./datenubersicht.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DatenubersichtComponent extends DatenubersichtCommonComponent implements OnInit {
    LANGUAGE = LANGUAGE_ENUM.DE;

    heatmapParameters: any[] = [
        { label: 'Beschwerdebild', selected: true },
        { label: 'Behandelte Symptome', selected: true },
        { label: 'Indikation', selected: false },
        { label: 'Cannabisarzneimittel', selected: false },
        { label: 'Alter', selected: false },
        { label: 'Geschlecht', selected: false },
        { label: 'CAM Therapieform', selected: false }
    ]

    constructor(protected cd: ChangeDetectorRef,
        protected vcr: ViewContainerRef,
        protected sharedService: SharedService) {
        super(cd, vcr, sharedService);
    }

    ngOnInit(): void {
        this.getHeatMapData();
    }


    getHeatMapData() {
        this.showLoader = true;
        this.sharedService.getHeatMapData().subscribe({
            next: (res) => {
                this.dataList = res;
                this.fnGenerateDiagram();
                this.showLoader = false;
            },
            error: (err) => {
                this.dataList = [];
                this.fnGenerateDiagram();
                this.showLoader = false;

            }
        })
    }
}
